module.exports = __webpack_public_path__ + "img/clientSlide06Img_03.43f82236.png";